import { AnswerDto, QuizProgressDto } from './progress.dto';

export class Answer {
    readonly questionId: string;
    readonly optionId: string;
    readonly textAnswer: string;
    readonly correct: boolean | null;

    constructor(data: AnswerDto) {
        this.questionId = data.questionId ?? '';
        this.optionId = data.optionId ?? '';
        this.textAnswer = data.textAnswer ?? '';
        this.correct = data.correct ?? null;
    }
}

export class QuizProgress {
    readonly moduleIds: string[];
    readonly courseIds: string[];
    readonly pathwayIds: string[];
    readonly quizId: string;
    readonly passed: boolean;
    readonly finished: boolean;
    readonly answers: Answer[];

    constructor(data: QuizProgressDto) {
        this.quizId = data.quizId ?? '';
        this.passed = data.passed ?? false;
        this.finished = data.finished ?? false;
        this.answers = data.answers?.map((a) => new Answer(a)) ?? [];
        this.moduleIds = data.moduleIds;
        this.courseIds = data.courseIds;
        this.pathwayIds = data.pathwayIds;
    }
}
